import { apiRequest } from './client';
import type { SalesforceAgent, UpdateAgentAssignmentInput, AgentFilters, UUID } from '@/types';

export const agentsApi = {
  list(tenantId: UUID, filters?: AgentFilters): Promise<SalesforceAgent[]> {
    const params = new URLSearchParams();
    if (filters?.salesforce_org_id) params.set('salesforce_org_id', filters.salesforce_org_id);
    if (filters?.search) params.set('search', filters.search);
    const qs = params.toString();
    return apiRequest(`/api/v1/tenants/${tenantId}/agents${qs ? `?${qs}` : ''}`, { tenantId });
  },

  get(tenantId: UUID, agentId: UUID): Promise<SalesforceAgent> {
    return apiRequest(`/api/v1/tenants/${tenantId}/agents/${agentId}`, { tenantId });
  },

  syncFromSalesforce(tenantId: UUID, orgId?: UUID): Promise<{ synced: number }> {
    return apiRequest(`/api/v1/tenants/${tenantId}/agents/sync`, {
      method: 'POST',
      body: orgId ? { salesforce_org_id: orgId } : {},
      tenantId,
    });
  },

  updateAssignment(
    tenantId: UUID,
    agentId: UUID,
    input: UpdateAgentAssignmentInput
  ): Promise<SalesforceAgent> {
    return apiRequest(`/api/v1/tenants/${tenantId}/agents/${agentId}`, {
      method: 'PATCH',
      body: input,
      tenantId,
    });
  },
};
